import type { SectionName } from '@coursera/event-pulse-types';

/** Section name for event-pulse tracking: AI summary block on search results. */
export const SEARCH_AI_SUMMARY_SECTION: SectionName = 'search_ai_summary';

/** Section name for event-pulse tracking: NL (natural language) suggestions on search results. */
export const SEARCH_NL_SUGGESTIONS_SECTION: SectionName = 'search_nl_suggestions';
